import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgModule, Provider } from '@angular/core';
import {
	MsalBroadcastService,
	MsalGuard,
	MsalGuardConfiguration,
	MsalInterceptor,
	MsalInterceptorConfiguration,
	MsalModule,
	MsalService,
	MSAL_GUARD_CONFIG,
	MSAL_INSTANCE,
	MSAL_INTERCEPTOR_CONFIG,
} from '@azure/msal-angular';
import {
	BrowserCacheLocation,
	InteractionType,
	IPublicClientApplication,
	LogLevel,
	PublicClientApplication,
} from '@azure/msal-browser';
import { environment } from 'src/environments/environment';
import { MsalAuthInterceptor } from './msal-auth.interceptor';

const isIE =
	window.navigator.userAgent.indexOf('MSIE ') > -1 ||
	window.navigator.userAgent.indexOf('Trident/') > -1;

export function loggerCallback(_logLevel: LogLevel, _message: string) {
}

export function MSALInstanceFactory(): IPublicClientApplication {
	return new PublicClientApplication({
		auth: {
			clientId: environment.activeDirectoryOptions.clientId,
			authority:
				environment.activeDirectoryOptions.instance +
				environment.activeDirectoryOptions.tenant,
			redirectUri: environment.activeDirectoryOptions.redirectUri,
			postLogoutRedirectUri:
				environment.activeDirectoryOptions.postLogoutRedirectUri,
		},
		cache: {
			cacheLocation: BrowserCacheLocation.LocalStorage,
			storeAuthStateInCookie: isIE, // set to true for IE 11
		},
		system: {
			loggerOptions: {
				loggerCallback,
				logLevel: LogLevel.Info,
				piiLoggingEnabled: false,
			},
		},
	});
}

export function MSALInterceptorConfigFactory(): MsalInterceptorConfiguration {
	const protectedResourceMap = new Map<string, Array<string>>();
	protectedResourceMap.set(environment.API_BASE_URL, environment.activeDirectoryOptions.scopes);
	return {
		interactionType: InteractionType.Redirect,
		protectedResourceMap,
	};
}

export function MSALGuardConfigFactory(): MsalGuardConfiguration {
	return {
		interactionType: InteractionType.Redirect
	};
}

const msalModules = [MsalModule];

const msalProviders: Provider[] = [
	{
		provide: HTTP_INTERCEPTORS,
		useClass: MsalAuthInterceptor,
		multi: true
	},
	{
		provide: HTTP_INTERCEPTORS,
		useClass: MsalInterceptor,
		multi: true,
	},
	{
		provide: MSAL_INSTANCE,
		useFactory: MSALInstanceFactory,
	},
	{
		provide: MSAL_GUARD_CONFIG,
		useFactory: MSALGuardConfigFactory,
	},
	{
		provide: MSAL_INTERCEPTOR_CONFIG,
		useFactory: MSALInterceptorConfigFactory,
	},
	MsalService,
	MsalGuard,
	MsalBroadcastService,
];

@NgModule({
	imports: [...msalModules],
	providers: [
		...msalProviders
	],
})
export class MsalAuthModule { }
